module.exports = __webpack_public_path__ + "img/switch_home.9a0e537f.gif";